import { render, staticRenderFns } from "./MoneyClaimDetails.vue?vue&type=template&id=5323a35d&"
import script from "./MoneyClaimDetails.vue?vue&type=script&lang=js&"
export * from "./MoneyClaimDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports